import { createFileRoute } from "@tanstack/react-router";
import { UnauthorizedPage } from "../pages/UnauthorizedPage";

// Search params type for the unauthorized route
export interface UnauthorizedSearchParams {
  attemptedRoute?: string;
  requiredPermission?: string;
  moduleName?: string;
}

export const Route = createFileRoute("/unauthorized")({
  validateSearch: (
    search: Record<string, unknown>
  ): UnauthorizedSearchParams => ({
    attemptedRoute: search.attemptedRoute as string | undefined,
    requiredPermission: search.requiredPermission as string | undefined,
    moduleName: search.moduleName as string | undefined,
  }),
  component: UnauthorizedPage,
});
